import React from "react";
import SharedControlPanel from "../../TypeA/Layout/ControlPanel.shared";

const { CONTROL_PANEL_CONFIGS } = require("../../Common/controlPanelConfig");

export default function TypeBControlPanel(props) {
    return (
        <SharedControlPanel
            {...props}
            panelConfig={CONTROL_PANEL_CONFIGS.typeB}
        />
    );
}
